// dependencies
import { fromJS } from "immutable";

const UIState = fromJS({
	editingGroupName: "",
	openCurtain: null,
	isGroupNameEditable: false,
	userIsAGroupAdmin: false,
	activeScreen: "MEMBERS",
	memberQueue: [],
	employeesColumns: [],

	columnWidths: {
		_displayName: 400,
		_jobTitle: 250,
		_remove: 50,
	},

	permissions: {
		"group-goals": false,
		"group-reviews": false,
		"group-feedback": false,
	},
});

export default UIState;
